import { gql } from '@apollo/client';
import Fragments from './fragments';

export const PAGED_EXCHANGE_RATES_QUERY = gql`
  query pagedExchangeRates($pager: PagerInputNew, $filters: ExchangeRatesFilterInput) {
    pagedExchangeRates(pager: $pager, filters: $filters) {
      total
      values {
        ...exchangeRate
      }
    }
  }
  ${Fragments.exchangeRate}
`;

export const BANKS_QUERY = gql`
  query banks {
    banks {
      bankId
      bankName
    }
  }
`;
